import { render, staticRenderFns } from "./PhysicalActivitiesAway.vue?vue&type=template&id=58d1f957"
import script from "./PhysicalActivitiesAway.vue?vue&type=script&lang=js"
export * from "./PhysicalActivitiesAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports